<template>
  <main
    id="page-top"
    tabindex="-1"
  >
    <the-main-nav />
    <v-main
      id="full-container-content"
    >
      <router-view v-if="!$slots.default" />
      <slot />
    </v-main>
    <the-footer />
  </main>
</template>

<script>
import TheMainNav from '@/components/core/the-main-nav'
import TheFooter from '@/components/core/the-footer'

export default {
  name: 'FullContainer',
  components: {
    TheFooter,
    TheMainNav
  },
  /* This handler will capture the errors of any child components, and allow the app to continue functioning.
  * The error will still be propagated to the global error handler, which will send it to App Insights
  * and redirect to the error page.
  */
  errorCaptured: (err) => {
    return err
  }
}
</script>
